import './index.scss';
import React, { Component } from 'react';
import { cloneDeep, differenceWith, isEqual } from 'lodash';
import { convertToArray, convertToArrayProdSeries } from '../../common/index';
import { getBaseCodes, getProductSubSeries } from '../../repositories';
import FilteredTwoColumnMultiSelect from '../../../shared/components/filteredTwoColumnMultiSelect';
import PropTypes from 'prop-types';
import {
    getProductSeries,
} from '../../../app/common/repositories';

class ProductSearch extends Component {

    state = {

        productSubSeriesList: [],
        productBaseCodeList: [],
        productSeriesList: [],

    };

    componentWillMount = () => {

        const factoryCode = this.props.defaultProperties.factoryCode === '-1'
            ? '' : this.props.defaultProperties.factoryCode;

        if ( factoryCode !== '' ) this.refreshDropDownsWithDefault( factoryCode );

    }

    componentWillReceiveProps ( nextProps ) {

        if ( this.props.defaultProperties.factoryCode !==
            nextProps.defaultProperties.factoryCode ) {

            if ( nextProps.defaultProperties.factoryCode !== '' ) {

                this.refreshAllDropDowns(
                    nextProps.defaultProperties.factoryCode,
                );

            } else {

                this.setState( {
                    productSubSeriesList: [],
                    productBaseCodeList: [],
                    productSeriesList: [],
                } );

            }

        }

    }

    refreshDropDownsWithDefault = factoryCode => {

        this.getProdSeries( factoryCode );
        this.handleSeriesOnChange( this.props.defaultProperties.productSeriesIds );
        this.handleSubSeriesChange( this.props.defaultProperties.productSubSeriesIds );

    }

    refreshAllDropDowns = factoryCode => {

        this.getProdSeries( factoryCode );
        this.getPrdSubSeries( factoryCode );
        this.getBaseCode( factoryCode );

        const propertiesToUpdate = {
            productSeriesIds: '',
            productSubSeriesIds: '',
            baseCodeIds: '',
        };

        this.sendMultipleStatus( propertiesToUpdate );


    }

    handleBaseCodeChange = selectedOption => {

        const selectedOptionList = this.props.defaultProperties.baseCodeIds === '' ? [] : this.props.defaultProperties.baseCodeIds;

        if ( selectedOption.length !== 0 ) {

            selectedOption.forEach( ele => {

                if ( !selectedOptionList.includes( ele ) ) {

                    selectedOptionList.push( ele );

                }

            } );

            this.sendStatus( 'baseCodeIds', selectedOptionList );

        }

    };

    handleSubSeriesChange = selectedOption => {

        const selectedOptionList = [];
        if ( selectedOption.length !== 0 ) {

            selectedOption.forEach( ele => {

                if ( !selectedOptionList.includes( ele ) ) {

                    selectedOptionList.push( ele );

                }

            } );

            this.sendStatus( 'productSubSeriesIds', selectedOptionList );
            const subSeriesIds = convertToArray( selectedOptionList ).join( ',' );
            const prdSeries = convertToArrayProdSeries( this.props.defaultProperties.productSeriesIds );
            this.getBaseCode(
                this.props.defaultProperties.factoryCode,
                prdSeries,
                subSeriesIds,
            );

        } else {

            this.getBaseCode(
                this.props.defaultProperties.factoryCode,
                this.props.defaultProperties.productSeriesId,
            );

        }

    };

    sendStatus = ( propertyName, propertyValue ) => {

        const propertiesToUpdate = {
            [propertyName]: propertyValue === null ? '' : propertyValue,
        };
        this.props.onUpdateProperty( propertiesToUpdate );

    }

    sendMultipleStatus = updatedProps => {

        this.props.onUpdateProperty( updatedProps );

    }

    handleSeriesOnChange = selectedOption => {

        if ( selectedOption.length !== 0 ) {

            const selectedOptionList = selectedOption.map( ele => ( { ...ele, label: ele.productSeriesName } ) );

            this.props.defaultProperties.productSeriesIds = selectedOptionList;
            this.sendStatus( 'productSeriesIds', selectedOptionList );
            const prodSeriesIds = convertToArrayProdSeries( selectedOptionList ).join( ',' );
            this.getPrdSubSeries( this.props.defaultProperties.factoryCode, prodSeriesIds );
            this.getBaseCode( this.props.defaultProperties.factoryCode, prodSeriesIds );

        } else {

            this.getPrdSubSeries(
                this.props.defaultProperties.factoryCode,
                this.props.defaultProperties.productSeriesIds,
            );
            this.getBaseCode(
                this.props.defaultProperties.factoryCode,
                this.props.defaultProperties.productSeriesIds,
            );

        }

    };


    getProdSeries = factoryCode => {

        getProductSeries( factoryCode ).then( response => {

            this.setState( {
                productSeriesList: response,
            } );

        } );

    };

    getPrdSubSeries = ( factoryCode, prdSeries ) => {

        const prodSeries = [prdSeries];
        getProductSubSeries( factoryCode, prodSeries ).then( response => {

            const recSubSeries = [];
            response.forEach( subSeries => {

                recSubSeries.push( {
                    value: subSeries.productSubSeriesId,
                    label: subSeries.productSubSeriesName,
                } );

            } );
            this.setState( {
                productSubSeriesList: recSubSeries,
            } );

        } );

    }

    getBaseCode = ( factoryCode, prdSeries = 0, prdSubSeries = 0 ) => {

        getBaseCodes(
            factoryCode,
            prdSeries,
            prdSubSeries,
        )
            .then(
                response => {

                    const recBaseCode = [];
                    response.forEach( baseCode => {

                        recBaseCode.push( {
                            value: baseCode.baseCodeId,
                            label: baseCode.baseCodeName,
                        } );

                    } );
                    this.setState( {
                        productBaseCodeList: recBaseCode,
                    } );

                },
            );

    }

    handleDeselectProductSeries = index => {

        const selectedProdSeries = this.props.defaultProperties.productSeriesIds.slice();
        selectedProdSeries.splice( index, 1 );
        const prodSeriesIds = convertToArrayProdSeries( selectedProdSeries ).join( ',' );
        this.getPrdSubSeries( this.props.defaultProperties.factoryCode, prodSeriesIds );
        this.getBaseCode( this.props.defaultProperties.factoryCode, prodSeriesIds );
        this.sendStatus( 'productSeriesIds', selectedProdSeries );

    }

    handleDeselect = index => {

        const selectedSubSeries = this.props.defaultProperties.productSubSeriesIds.slice();
        selectedSubSeries.splice( index, 1 );
        const subSeriesIds = convertToArray( selectedSubSeries ).join( ',' );
        const prdSeries = convertToArrayProdSeries( this.props.defaultProperties.productSeriesIds );
        this.getBaseCode(
            this.props.defaultProperties.factoryCode,
            prdSeries,
            subSeriesIds,
        );
        this.sendStatus( 'productSubSeriesIds', selectedSubSeries );

    }

    handleDeselectBaseCode = index => {

        const selectedBaseCodes = this.props.defaultProperties.baseCodeIds.slice();
        selectedBaseCodes.splice( index, 1 );
        this.sendStatus( 'baseCodeIds', selectedBaseCodes );

    }

    handleClearAll = type => {

        if ( type === 'productSeriesIds' ) {

            this.sendStatus( 'productSeriesIds', '' );
            this.getPrdSubSeries( this.props.defaultProperties.factoryCode );
            this.getBaseCode( this.props.defaultProperties.factoryCode );

        } else if ( type === 'productSubSeriesIds' ) {

            this.sendStatus( 'productSubSeriesIds', '' );
            this.getBaseCode( this.props.defaultProperties.factoryCode );

        } else {

            this.sendStatus( 'baseCodeIds', '' );

        }

    }

    filteredList = ( options, selectedOpt ) => {

        const defaultProperties = cloneDeep( options );
        const modifiedProperties = cloneDeep( selectedOpt );
        let modifiedInput = [];
        if ( !isEqual( modifiedProperties, defaultProperties ) ) {

            modifiedInput = differenceWith(
                defaultProperties, modifiedProperties, ( !isEqual ),
            );


        }
        return modifiedInput;

    }


    render () {

        return (
            <section className="product-search">
                <span className={`product-search-alert ${this.props.defaultProperties.factoryCode === '' ? 'show' : 'hide'}`}>Please select Factory Code to Enable this Criteria</span>
                <main>
                    <div className="panel">
                        <div className="rows">
                            <FilteredTwoColumnMultiSelect
                                label="Product Series"
                                onChange={this.handleSeriesOnChange.bind( this.props )}
                                options={this.filteredList( this.state.productSeriesList, this.props.defaultProperties.productSeriesIds === '' ? [] : this.props.defaultProperties.productSeriesIds )}
                                textProp="productSeriesName"
                                valueProp="productSeriesId"
                                className="claim-product-series"
                                disabled={this.props.defaultProperties.factoryCode === ''}
                                selectedOptions={this.props.defaultProperties.productSeriesIds === '' ? [] : this.props.defaultProperties.productSeriesIds}
                                handleDeselect={this.handleDeselectProductSeries}
                                handleClearAll={() => this.handleClearAll( 'productSeriesIds' )}
                            />
                        </div>
                        <div className="rows">
                            <FilteredTwoColumnMultiSelect
                                label="Product Sub Series"
                                onChange={this.handleSubSeriesChange}
                                options={this.filteredList( this.state.productSubSeriesList, this.props.defaultProperties.productSubSeriesIds === '' ? [] : this.props.defaultProperties.productSubSeriesIds )}
                                textProp="label"
                                valueProp="value"
                                className="product-sub-series"
                                disabled={this.props.defaultProperties.factoryCode === ''}
                                selectedOptions={this.props.defaultProperties.productSubSeriesIds === '' ? [] : this.props.defaultProperties.productSubSeriesIds}
                                handleDeselect={this.handleDeselect}
                                handleClearAll={() => this.handleClearAll( 'productSubSeriesIds' )}
                            />
                        </div>
                        <div className="rows">
                            <FilteredTwoColumnMultiSelect
                                label="Product BaseCode"
                                onChange={this.handleBaseCodeChange}
                                options={this.filteredList( this.state.productBaseCodeList, this.props.defaultProperties.baseCodeIds === '' ? [] : this.props.defaultProperties.baseCodeIds )}
                                textProp="label"
                                valueProp="value"
                                className="product-basecode"
                                disabled={this.props.defaultProperties.factoryCode === ''}
                                selectedOptions={this.props.defaultProperties.baseCodeIds === '' ? [] : this.props.defaultProperties.baseCodeIds}
                                handleDeselect={this.handleDeselectBaseCode}
                                handleClearAll={() => this.handleClearAll( 'baseCodeIds' )}
                            />
                        </div>
                    </div>
                </main>
            </section>
        );

    }

}
ProductSearch.displayName = 'ProductSearch';
ProductSearch.propTypes = {
    onUpdateProperty: PropTypes.func.isRequired,
    defaultProperties: PropTypes.object.isRequired,

};

export default ProductSearch;
